import React from 'react'

interface CheckIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const CheckIcon: React.FC<CheckIconProps> = ({
  color = '#000',
  gradient = false,
  width = 18,
  height = 14,
  alt = 'Check icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 18 14'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillOpacity='0.87'
        fillRule='evenodd'
        d='M6 11.2L1.8 7 .4 8.4 6 14 18 2 16.6.6 6 11.2z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default CheckIcon
